import Image from "next/image";

const GolfSpinner = (props) => (
  <Image
    src="/GC_Spinner.gif"
    alt="Loading"
    width={props.width}
    height={props.height}
  />
);

export default GolfSpinner;
